import React from 'react'
import ViewManualAccountForm from '../../../features/GmpManualAccount/Component/ViewManualForm'

const ViewManualAccount = () => {
  return (
    <div>
      <ViewManualAccountForm />
    </div>
  )
}

export default ViewManualAccount
